export enum CheckboxSize {
  S = 's',
  M = 'm',
  L = 'l',
  XL = 'xl',
}

export enum CheckboxAppearance {
  Default = 'default',
  Dark = 'dark',
}
